import type { ExportedResourcesResponse } from '../../types';
import { logger } from '../../utils/logger';
import { authenticatedFetch } from '../../utils/authenticatedFetch';
import { getV2AuthHeaders } from '../../utils/authHeaders';
import { getEnv } from '../../config/env';

export const fetchExportedResourcesFromService = async (
  bearerToken: string,
  migrationId: string
): Promise<ExportedResourcesResponse> => {
  try {
    const baseUrl = getEnv().VITE_EDCI_API_URL;
    const url = `${baseUrl}/api/migrations/${migrationId}/exportedResources`;

    const response = await authenticatedFetch(url, {
      headers: getV2AuthHeaders(bearerToken)
    });

    if (!response.ok) {
      logger.error('Fetch exported resources API returned error', {
        status: response.status,
        statusText: response.statusText,
        migrationId,
        url
      });
      throw new Error(
        `Error fetching exported resources: ${response.status} ${response.statusText}`
      );
    }

    const data: ExportedResourcesResponse = await response.json();
    logger.info('Exported resources fetched successfully', {
      migrationId,
      stage: data.stage,
      totalTypes: data.totalTypes,
      totalResources: data.totalResources
    });
    return data;
  } catch (error) {
    const msg = error instanceof Error ? error.message : String(error);
    logger.error('Failed to fetch exported resources', {
      error: msg,
      migrationId,
      url: `${getEnv().VITE_EDCI_API_URL}/api/migrations/${migrationId}/exportedResources`
    });
    throw error;
  }
};

export default fetchExportedResourcesFromService;
